import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Flex } from 'antd-mobile';
import styles from './index.modules.less';

export default forwardRef(({ tab, tabs, activeIndex, titleOpacity, idx }, ref) => {
  const isChoose = tab == tabs[activeIndex];
  return (
    <Flex
      align="center"
      justify="center"
      direction="column"
      style={
        isChoose
          ? {
              backgroundColor: '#FFF3F5',
              border: '1rpx solid #FFB7C3',
              opacity: titleOpacity
            }
          : {
              opacity: titleOpacity
            }
      }
      className={styles.titleView}>
      <Flex style={{ color: isChoose ? '#F01B3F' : '#333333' }} className={styles.mainTitle}>
        {tab.title}
      </Flex>
      <Flex Flex style={{ color: isChoose ? '#FF5875' : '#666666' }} className={styles.subTitle}>
        {tab.subTitle}
      </Flex>
      {isChoose && (
        <Flex justify="center" style={{ width: '100%', position: 'absolute', left: 0, bottom: 0 }}>
          <Flex className={styles.bottomView} />
        </Flex>
      )}
    </Flex>
  );
});



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/RenderTab/index.jsx